<div class="container">
    <div class="main">
        <div class="close-btn pointer">
            <img src="assets/icon/cancel_icon.svg" alt="close" (click)="closeDialog('NO');crossBtnGA()">
        </div>
        <div class="content">
            <h4>Sorry, you have to log out a previous session first to continue here.</h4>
        </div>
        <div class="button">
            <button type="button" class="btns btn-no" (click)="closeDialog('NO')">No</button>
            <button type="button" class="btns btn-yes" (click)="closeDialog('YES')">Log out</button>
        </div>
    </div>
</div>